import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function getPurchaseStories(purchaseId, page = 0, size = 10, signal) {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/purchases/${encodeURIComponent(purchaseId)}/stories`, {
        params: { mediaType: 'mp4', page, size },
        signal,
        headers: { Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}` },
    });
    const result = response.data;
    if (String(result?.status?.code) !== '10200' || !Array.isArray(result?.data?.stories)) {
        const error = new Error(result?.status?.message || 'Unable to load stories.');
        error.response = response;
        throw error;
    }
    return {
        ...result.data,
        stories: result.data.stories.map(story => ({
            ...story,
            storyId: story._id,
            expiryOn: story.expiryDate,
            totalClapCount: story.iimjobsClapCount ?? story.totalClapCount,
            totalViewCount: story.iimjobsViewCount ?? story.totalViewCount,
            totalScrollCount: story.iimjobsScrollCount ?? story.totalScrollCount,
        })),
    };
}
